import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { successState, apiCallFailure } from 'app/actions';
import routerActions from 'app/routerActions';
import { toKBArrayField, toKBField, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { showApiError } from 'utils/feedback';
import {
KBForm,
KBInput,
KBSelect,
KBImageCropperInput,
KBButton,
KBMorePhotoUpload,
KBMoreFileUpload } from
'components';
import { api } from 'app/services';
import { Select } from 'antd';
import KBEditor from 'components/plugins/KBEditor';

const renderPlayBookContent = ({ input, meta }) => (
  <KBEditor field={toKBField(input, meta)} title="服务介绍详情" isRequired />
);

const renderPlayBookPdf = ({ fields }) => {
  const pdf = toKBArrayField(fields);
  return <KBMoreFileUpload
    uploadingText="正在上传"
    uploadedText="点击上传"
    sort={false}
    multiple={false}
    className="kb-form-group kb-form-alone"
    field={pdf}
    text="上传附件"
    accept=".pdf"
    title="请上传Playbook完整版"
    fileType="attachments"
    isPublic={true}
    isRequired={true}
    maxSize={10}
    disabled={pdf.length} />;
};

const renderPlayBookPdfError = ({ input, meta }) => {
  const pdfError = toKBField(input, meta);
  return pdfError.touched && pdfError.error ? <p className="lr-error">{pdfError.error}</p> : <p style={{ color: '#c8c8c8', fontSize: 12 }}>附件格式为PDF，文件大小限制10M</p>;
};

var EditPlayBook = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.getDetail = this.getDetail.bind(this);this.goBack = this.goBack.bind(this);this.submitData = this.submitData.bind(this);this.failureCallBack = this.failureCallBack.bind(this);this.changeServicesList = this.changeServicesList.bind(this);}getInitialState()
  {
    return {
      editId: null };

  }componentDidMount()

  {
    this.getDetail();
    // const { editId } = this.props.location.query

    // if (editId) {
    //   // 获取详情数据
    //   const {
    //     fields: { name, category, icon, desc_image, tag_list }
    //   } = this.props
    //   api.getValueAddedServiceDetail(editId).then(({ json }) => {
    //     name.onChange(json.name)
    //     category.onChange(json.category)
    //     icon.onChange(json.icon)
    //     desc_image.onChange(json.desc_image)
    //     tag_list.onChange(json.tag_list)
    //   })
    // }
  }getDetail()

  {
    const {
      params: { id },
      change } =
    this.props;
    api.
    getValueAddedServicesList({
      location_group_id: id,
      category: 'playbook' }).
    then(res => {
      if (res && res.json && res.json.length) {
        // 编辑
        const { content, pdf_url, id } = res.json[0];
        this.setState({
          editId: id });

        change('content', content);
        change('pdf', [{ url: pdf_url }]);

      }
    });
  }goBack()

  {
    this.props.routerActions.goBack();
  }submitData(

  model) {
    const {
      params: { id },
      apiCallFailureAction,
      successAction,
      routerActions } =
    this.props;
    const { editId } = this.state;
    if (!editId) {
      // 新建
      api.
      addValueAddedService({
        content: model.content,
        pdf_url: model.pdf[0].url,
        location_group_id: id,
        category: 'playbook',
        name: 'playbook' }).

      then(res => {
        successAction({ message: '创建成功' });
        routerActions.push(`/admin/groups/${id}/valueAddedServices`);
      }).
      catch(error => {
        apiCallFailureAction({
          status: 'error',
          message: error.message });

      });
    } else {
      // 编辑
      api.
      editValueAddedService(editId, {
        content: model.content,
        pdf_url: model.pdf[0].url,
        location_group_id: id,
        category: 'playbook',
        name: 'playbook' }).

      then(res => {
        successAction({ message: '修改成功' });
        routerActions.push(`/admin/groups/${id}/valueAddedServices`);
      }).
      catch(error => {
        apiCallFailureAction({
          status: 'error',
          message: error.message });

      });
    }
  }failureCallBack(

  err) {
    if (!err) return;
    return showApiError('上传失败', err);
  }changeServicesList(

  val) {
    this.props.change('tag_list', val);
  }render()

  {
    const {
      submitting,
      handleSubmit } =
    this.props;

    return (
      <div className="kb-content-container">
        <KBForm
        type="reduxForm"
        onSubmit={handleSubmit(this.submitData)}>

          <header className="kb-form-header">
            <h2 className="header-title">设置Playbook</h2>
          </header>
          <div className="kb-form-container">
            <Field name="content"
	component={renderPlayBookContent} />

            <div className="kb-row" style={{ textAlign: 'left' }}>
              <FieldArray name="pdf"
	component={renderPlayBookPdf} />

              <Field name="pdfError"
	component={renderPlayBookPdfError} />
            </div>

            <div className="kb-row" style={{ marginTop: '80px' }}>
              <span className="cancel-btn" onClick={this.goBack}>
                取消
              </span>
              <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

                保存
              </KBButton>
            </div>
          </div>
        </KBForm>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { params } = props;

  return {
    initialValues: {
      tag_list: [] } };


}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    apiCallFailureAction: bindActionCreators(apiCallFailure, dispatch),
    successAction: bindActionCreators(successState, dispatch) };

}

const validate = values => {
  const errors = {};

  if (!values.content || values.content === '<p><br></p>') {
    errors.content = '请输入活动详情';
  }

  if (!values.pdf || !values.pdf.length) {
    errors.pdfError = '请上传Playbook完整版';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name",
  "category",
  "icon",
  "desc_image",
  "content",
  "pdf[].url",
  "pdfError"
];

const formConfig = {
  form: 'EditPlayBook',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('EditPlayBook', LEGACY_FORM_FIELDS)(EditPlayBook)));
